import React, { Component } from "react";
import { renderInterestTracks } from './fpgViewHelpers';
import { Link } from "react-router-dom";
import mediaImage from "./../../../assets/images/user.jpg";
import TwitterIcon from "./../../../icons/twittericon";
import InstaIcon from "./../../../icons/instaicon";
import TextField from "./../../../component/TextField";
import FpgeeditIcon from "./../../../icons/fpgediticon";
import FpgDisableIcon from "./../../../icons/fpgdisableicon";
import FpgpublishIcon from "./../../../icons/fpgpublishicon";
import FpgDeleteIcon from "./../../../icons/fpgdeleteicon";
import ShowPassIcon from "../../../icons/ShowPassIcon";
import ViewIcon from "../../../icons/viewIcon";
import RefreshIcon from './../../../icons/refreshicon';
import Slider from "react-slick";
//moment import
import moment from "moment";
//Service import
import service from "../../../services";
import ErrorPopUp from '../../errorPopUp';
import RecordPresenceBanner from "../../RecordPresenceBanner";

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../../redux/bindActionCretor'
import PopUpCustomAll from "../create/popUpCustomAll";
//Validation import
import SimpleReactValidator from 'simple-react-validator';
import Loader from "../../loader";
import FpgMinusIcon from "../../../icons/fpgminusicon";

let sub;

const getEmbedUrl = (url) => {
    if (!url) return '';
    if (url.includes('youtube.com/embed/') || url.includes('player.vimeo.com/video/')) return url;
    const ytMatch = url.match(/(?:youtube\.com\/watch\?[^#]*v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    return url;
};

const mapStateToProps = state => ({
  filmEditId: state.filmEditId,
  profileName: state.profileName,
  recordViewers: state.recordViewers,
  recordConflict: state.recordConflict,
  getLoginAdminByID: state.getLoginAdminByID
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};


class FpgFilmDetailView extends Component {
  constructor() {
    super();
    this.state = {
      screening: '',
      errorPopup: false,
      getAlldataFilm: [],
      loaderFlag: false,
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      hideFromLiveFilm: false,
      showFromLiveFilm: false,
      screencontent: false,
      artist: [],
      teamConnectionFirstName: '',
      teamConnectionFirstEmail: '',
      teamConnectionSecondName: '',
      teamConnectionSecondEmail: '',
      holdSceeringAvailableOpted: '',
      waitList_show:false,
      onlineScreeningShow : false,
      shortFilms: [],
      shortIntroduction: '',
      film: {}

    };
    this.apiserve = new service();
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this._hasLeftPresence = false;
  }

  componentDidMount() {
    this.props.ClearRecordPresence();
    {
      this.props.filmEditId &&
        this.apiserve.sendevent("user|sff|getAllInitialForRedis", {});
        this.getAlldetails();
      this.getdetails();
    }

    this.setState({
      loaderFlag: true,
    });

    // RecordPresence: Join if recordId exists
    if (this.props.filmEditId) {
      this.apiserve.sendevent("RecordPresence|join", {
        modelName: "film",
        recordId: this.props.filmEditId
      });
      // Add beforeunload handler
      this._handleBeforeUnload = () => {
        if (!this._hasLeftPresence) {
          this._hasLeftPresence = true;
          this.apiserve.sendevent("RecordPresence|leave", {
            modelName: "film",
            recordId: this.props.filmEditId
          });
        }
      };
      window.addEventListener('beforeunload', this._handleBeforeUnload);
    }
  }

  componentWillUnmount = () => {
    sub.unsubscribe();
    if (this.props.filmEditId && !this._hasLeftPresence) {
      this._hasLeftPresence = true;
      this.apiserve.sendevent("RecordPresence|leave", {
        modelName: "film",
        recordId: this.props.filmEditId
      });
    }
    if (this._handleBeforeUnload) {
      window.removeEventListener('beforeunload', this._handleBeforeUnload);
    }
    this.props.ClearRecordPresence();
  }

  closeAdminUser = () => {
    this.setState({
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      hideFromLiveFilm: false,
      showFromLiveFilm: false
    })
  }

  getdetails = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "film|getAllDetail":
          if (!response.error) {
            // let data = response.data.screening;
           
            //   data.screenDetails && data.screenDetails.map(screen => {
            //     screen.screeningType === '' &&  delete screen['screeningType']
            //     response.data.dateTime.map(date => {
            //       if (screen._id === date._id) {
            //         screen.location = date.locations.length > 0 ? date.locations[0]._id : '';
            //       }
            //       if(date.locations.length > 0) {
            //         this.setState({
            //           waitList_show:true 
            //         })
            //       }
            //     })
            //   })
              // var screen = data.screenDetails.sort((a, b) => new Date(b.date) - new Date(a.date));
            this.setState(
              {
                access: response.data.access && response.data.access.name,
                eventiveId:response.data.eventiveId,
                getAlldataFilm: response.data,
                mediaId: response.data.mediaId,
                fileMakerId: response.data.fileMakerId,
                // shift72Id: response.data.shift72Id,
                images: response.data.images,
                contact: response.data.contact,
                credits: response.data.credits,
                artist: response.data.artist,
                article: response.data.article,
                year: response.data.year,
                category: response.data.category,
                country: response.data.country,
                language: response.data.language,
                runTime: response.data.runTime,
                company: response.data.company,
                website: response.data.website,
                accessibility: response.data.accessibility,
                description: response.data.description,
                shortDescription: response.data.shortDescription,
                genre: response.data.genre,
                interestTrack: response.data.interestTrack,
                dateTime: response.data.dateTime,
                title: response.data.title,
                hideFromLive: response.data.hideFromLive,
                // myLibraryScreeningCode:response.data.myLibraryScreeningCode,
                status: response.data.status,
                categoryname: response.data.category.name,
                categorytype:response.data.category.type,
                qaReplayLink: response.data.qaReplayLink,
                shortProgramme: response.data.shortProgramme,
                awardCategory: response.data.awardCategory && response.data.awardCategory.name,
                awardSponsorLogo: response.data.awardSponsorLogo,
                // votes: response.data.votes,
                // isAudioDescription: response.data.isAudioDescription,
                // audioDescriptionShift72Id: response.data.audioDescriptionShift72Id,
                isExplicitContent: response.data.isExplicitContent,
                explicitContent: response.data.explicitContent,
                sponsorLogo: response.data.sponsorLogo,
                screeningMoreInfoTitle: response.data.screeningMoreInfoTitle,
                screeningMoreInfo: response.data.screeningMoreInfo,
                teamConnectionFirstName: response.data.teamConnection[0] && response.data.teamConnection[0].name ? response.data.teamConnection[0].name : '',
                teamConnectionFirstEmail: response.data.teamConnection[0] && response.data.teamConnection[0].email ? response.data.teamConnection[0].email : '',
                teamConnectionSecondName: response.data.teamConnection[1] && response.data.teamConnection[1].name ? response.data.teamConnection[1].name : '',
                teamConnectionSecondEmail: response.data.teamConnection[1] && response.data.teamConnection[1].email ? response.data.teamConnection[1].email : '',
                // totalAllow: response.data.screening ? response.data.screening.totalAllow : { "inPerson": 0, "online": 0 },
                // total: response.data.screening && response.data.screening.totalAllow && response.data.screening.totalAllow.inPerson,
                // online: response.data.screening && response.data.screening.totalAllow && response.data.screening.totalAllow.online,
                // awardWinneraAllowed: response.data.screening && response.data.screening.awardWinner && response.data.screening.awardWinner.allowed ? response.data.screening && response.data.screening.awardWinner && response.data.screening.awardWinner.allowed : 0,
                // awardWinneraOpted: response.data.screening && response.data.screening.awardWinner && response.data.screening.awardWinner.allowed ? response.data.screening && response.data.screening.awardWinner && response.data.screening.awardWinner.opted : 0,
                // awardWinneraConsumed: response.data.screening && response.data.screening.awardWinner && response.data.screening.awardWinner.consumed ? response.data.screening && response.data.screening.awardWinner && response.data.screening.awardWinner.consumed : 0,
                // catchUpAccessAllowed: response.data.screening && response.data.screening.catchUpAccess && response.data.screening.catchUpAccess.allowed ? response.data.screening && response.data.screening.catchUpAccess && response.data.screening.catchUpAccess.allowed : 0,
                // catchUpAccessOpted: response.data.screening && response.data.screening.catchUpAccess && response.data.screening.catchUpAccess.allowed ? response.data.screening && response.data.screening.catchUpAccess && response.data.screening.catchUpAccess.opted : 0,
                // catchUpAccessConsumed: response.data.screening && response.data.screening.catchUpAccess && response.data.screening.catchUpAccess.consumed ? response.data.screening && response.data.screening.catchUpAccess && response.data.screening.catchUpAccess.consumed : 0,
                // catchUpTicketsAllowed: response.data.screening && response.data.screening.catchUpTickets && response.data.screening.catchUpTickets.allowed ? response.data.screening && response.data.screening.catchUpTickets && response.data.screening.catchUpTickets.allowed : 0,
                // catchUpTicketsOpted: response.data.screening && response.data.screening.catchUpTickets && response.data.screening.catchUpTickets.opted ? response.data.screening && response.data.screening.catchUpTickets && response.data.screening.catchUpTickets.opted : 0,
                // catchUpTicketsConsumed: response.data.screening && response.data.screening.catchUpTickets && response.data.screening.catchUpTickets.consumed ? response.data.screening && response.data.screening.catchUpTickets && response.data.screening.catchUpTickets.consumed : 0,
                // industryReservationAllowed: response.data.screening && response.data.screening.premierTickets && response.data.screening.industryReservation.allowed ? response.data.screening && response.data.screening.premierTickets && response.data.screening.industryReservation.allowed : 0,
                // industryReservationOpted: response.data.screening && response.data.screening.industryReservation && response.data.screening.industryReservation.opted ? response.data.screening && response.data.screening.industryReservation && response.data.screening.industryReservation.opted : 0,
                // industryReservationConsumed: response.data.screening && response.data.screening.industryReservation && response.data.screening.industryReservation.consumed ? response.data.screening && response.data.screening.industryReservation && response.data.screening.industryReservation.consumed : 0,
                // premierTicketsAllowed: response.data.screening && response.data.screening.premierTickets && response.data.screening.premierTickets.allowed ? response.data.screening && response.data.screening.premierTickets && response.data.screening.premierTickets.allowed : 0,
                // premierTicketsOpted: response.data.screening && response.data.screening.premierTickets && response.data.screening.premierTickets.opted ? response.data.screening && response.data.screening.premierTickets && response.data.screening.premierTickets.opted : 0,
                // premierTicketsConsumed: response.data.screening && response.data.screening.premierTickets && response.data.screening.premierTickets.consumed ? response.data.screening && response.data.screening.premierTickets && response.data.screening.premierTickets.consumed : 0,
                // premierTicketsWaitList: response.data.screening && response.data.screening.premierTickets && response.data.screening.premierTickets.consumed ? response.data.screening && response.data.screening.premierTickets && response.data.screening.premierTickets.consumed : 0,
                // publicPassHolderAllowed: response.data.screening && response.data.screening.publicPassHolder && response.data.screening.publicPassHolder.allowed ? response.data.screening && response.data.screening.publicPassHolder && response.data.screening.publicPassHolder.allowed : 0,
                // publicPassHolderOpted: response.data.screening && response.data.screening.publicPassHolder && response.data.screening.publicPassHolder.opted ? response.data.screening && response.data.screening.publicPassHolder && response.data.screening.publicPassHolder.opted : 0,
                // publicPassHolderConsumed: response.data.screening && response.data.screening.publicPassHolder && response.data.screening.publicPassHolder.consumed ? response.data.screening && response.data.screening.publicPassHolder && response.data.screening.publicPassHolder.consumed : 0,
                lastUpdatedBy: response.data.screening && response.data.screening && response.data.screening.lastUpdatedBy,
                lastUpdatedAt: response.data.screening && response.data.screening && response.data.screening.lastUpdatedAt,
                // screenDetails: response.data.screening && response.data.screening.screenDetails,
                // online_held: response.data.screening && response.data.screening.totalHeld && response.data.screening.totalHeld.consumed,
                // total_held: response.data.screening && response.data.screening.totalHeld && response.data.screening.totalHeld.allowed,
                // onlineAllocation_allowed:response.data.screening && response.data.screening.onlineAllocation && response.data.screening.onlineAllocation.allowed,
                // onlineAllocation_consumed:response.data.screening && response.data.screening.onlineAllocation && response.data.screening.onlineAllocation.consumed,
                // inPersonAllocation_allowed:response.data.screening && response.data.screening.inPersonAllocation && response.data.screening.inPersonAllocation.allowed,
                // inPersonAllocation_consumed:response.data.screening && response.data.screening.inPersonAllocation && response.data.screening.inPersonAllocation.consumed
                publicContact:response.data.publicContact,
                postFestivalContact:response.data.postFestivalContact,
                shortIntroduction: response?.data?.shortIntroduction ?? "",
                shortFilms: response?.data?.shortFilms ?? [],
              },
              () => {
                this.setState({
                  loaderFlag: false,
                });
                this.props.setLastUpdated({
                  updatedAt: response?.data?.updatedAt,
                  updatedBy: {
                    fname: response?.data?.updatedBy?.fname,
                    lname: response?.data?.updatedBy?.lname
                  }
                })
              }
            );
            // let temp_array = []
            // response.data.screening.screenDetails && response.data.screening.screenDetails.map((item) => {
            //   response.data.dateTime.map((l => {
            //     if(l._id === item._id){
            //       if(item.locationType === "1" && l.locations.length > 0 && l.locations[0].venueType.name !== "Satellite Screen") {
            //         response.data.category.type === 1 ? temp_array.push(item) : response.data.category.type === 3 && temp_array.push(item)
            //       } else {
            //         response.data.category.type === 1 && item.locationType === "2" && temp_array.push(item)
            //       }
            //     } 
            //   }))
              
            //   // response.data.category.type === 1 ? temp_array.push(item) : response.data.category.type === 3 && item.locationType === "1" && temp_array.push(item) 
            // })
            // this.setState({
            //   screenDetails: temp_array
            // })
            // if(temp_array.length === 0){
            //   this.setState({
            //     onlineScreeningShow : true,
            //   })
            // }
            
          } else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "film|remove":
          if (!response.error) {
            this.props.history.push('/filmlist')
          } else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "film|updateStatus":
          if (!response.error) {
            this.setState({
              hideFromLiveFilm: false,
              disableFilm: false,
              publishFilm: false,
              showFromLiveFilm: false,
            })
            this.apiserve.success('Updated successfully')
            this.apiserve.sendevent("film|getAllDetail", { filmId: this.props.filmEditId });
          }
          else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "fpg|screening|update":
          if (!response.error) {
            this.getAlldetails();
            this.setState({
              loaderFlag: false
            })
          }
          else {
            this.setState({
              loaderFlag: false
            })
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "user|sff|getAllInitialForRedis":
          this.setState({
            film: response.data.film,
          })
          break;
        case "RecordPresence|viewersUpdate": {
          if (!response.error && response?.data?.recordId === this.props.filmEditId) {
            const currentUserId = this.props.getLoginAdminByID;
            const viewers = response?.data?.viewers || [];
            const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
            const currentUserHasMultipleSessions = currentUserSessionCount > 1;
            const seenIds = new Set();
            const filteredViewers = viewers
              .filter(v => {
                if (v?.userId === currentUserId) {
                  return currentUserHasMultipleSessions;
                }
                return true;
              })
              .filter(v => {
                if (seenIds.has(v?.userId)) return false;
                seenIds.add(v?.userId);
                return true;
              })
              .map(v => ({
                userId: v?.userId,
                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
              }));
            this.props.SetRecordViewers(filteredViewers);
          }
          break;
        }
      }
    });
    // setTimeout(() => {
    //   this.state.screenDetails && this.state.screenDetails.map((item) => {
    //     this.state.dateTime.map(date => {
    //       if (item._id === date._id) {
    //         item.location = date.locations.length > 0 ? date.locations[0]._id : '';
    //       }
    //       if(date.locations.length > 0) {
    //         this.setState({
    //           waitList_show:true 
    //         })
    //       }
    //     })
    //   })
    // }, 1000)
    this.setState({})
  };

  getAlldetails = () => {
    var data = { filmId: this.props.filmEditId };
    this.apiserve.sendevent("film|getAllDetail", data);
  };

  getDisplayValue = (accNo) => {
    const { profileName } = this.props;
    let accessValue = profileName.CMA.find(_ => _.access === accNo);
    return accessValue ? accessValue.value : false;
  }

  handelTwitter = (item) => {
    this.state.artist.forEach(element => {
      if (element._id === item._id) {
        window.open(item.twitter, "_blank");
      }
    });

  };

  handelInstagram = (item) => {
    this.state.artist.forEach(element => {
      if (element._id === item._id) {
        window.open(item.instagram, "_blank");
      }
    });

  };

  deleteFilm = () => {
    this.setState({
      deleteFilm: true
    })
  }

  deleteFilmPopupYes = () => {
    this.apiserve.sendevent("film|remove", {
      filmId: this.props.filmEditId
    });
  }

  hideFromLiveFilm = () => {
    this.setState({
      hideFromLiveFilm: true
    })
  }

  hideFromLiveFilmPopupYes = () => {
    this.apiserve.sendevent("film|updateStatus", {
      filmId: this.props.filmEditId,
      status:this.state.status,
      hideFromLive: true
    });
  }

  showFromLiveFilm = () => {
    this.setState({
      showFromLiveFilm: true
    })
  }

  showFromLiveFilmPopupYes = () => {
    this.apiserve.sendevent("film|updateStatus", {
      filmId: this.props.filmEditId,
      status:this.state.status,
      hideFromLive: false
    });
  }
  publishFilm = () => {
    this.setState({
      publishFilm: true
    })
  }

  publishFilmPopupYes = () => {
    this.apiserve.sendevent("film|updateStatus", {
      filmId: this.props.filmEditId,
      hideFromLive:this.state.hideFromLive,
      status: 1
    });
  }

  disableFilm = () => {
    this.setState({
      disableFilm: true
    })
  }

  disableFilmPopupYes = () => {
    this.apiserve.sendevent("film|updateStatus", {
      filmId: this.props.filmEditId,
      hideFromLive:this.state.hideFromLive,
      status: 2
    });
  }

  editFilmEvent = () => {
    // this.props.dispatch({type: 'CurrentTab', res: 0})
    this.props.CurrentTab(0)
    this.props.history.push({
      pathname: `/create-film/${this.props.filmEditId}/edit`,
      callFrom: 0
    });
  };

  ScreenToggle = (e) => {
    var active = e.target.parentNode.closest(".inner_screen").querySelector(".screen_header").classList.toggle("active");
    var parentactive = e.target.closest(".screen_header").parentNode.parentNode.classList.toggle("active");
    var panel = e.target.parentNode.closest(".inner_screen").querySelector(".screen_content_outer");
    if (panel && panel.style.maxHeight) {
      panel.style.maxHeight = "";
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
    this.setState({
      screencontent: !this.state.screencontent
    })
  }

  errorMsgPopup = () => {
    this.setState({
      errorPopup: false
    })
  }

  // handleChange = (e, id) => {
  //   const { name, value } = e.target;
  //   let screenDetails_new = []
  //   if (name === 'premierTicketsAllowed' || name === 'premierTicketsWaitList' || name === 'publicPassHolderAllowed' || name === 'industryReservationAllowed' || name === 'holdSceeringAvailableAllowed' || name === 'total' || name === 'online') {
  //     this.state.screenDetails.map((item) => {
  //       if (item._id === id && /^[0-9]*$/.test(e.target.value)) {
  //         item.singleTicket.allowed = name === "premierTicketsAllowed" ? value : item.singleTicket.allowed
  //         item.singleTicket.waitList = name === 'premierTicketsWaitList' ? value : item.singleTicket.waitList
  //         item.publicPackageTicket.allowed = name === 'publicPassHolderAllowed' ? value : item.publicPackageTicket.allowed
  //         item.piPackageTicket.allowed = name === 'industryReservationAllowed' ? value : item.piPackageTicket.allowed
  //         item.holdTickets.allowed = name === 'holdSceeringAvailableAllowed' ? value : item.holdTickets.allowed
  //       }
  //       if ((name === 'total' || name === 'online') && /^[0-9]*$/.test(e.target.value)) {
  //         this.setState({
  //           [name]: value
  //         })
  //       }
  //      this.state.dateTime.map(l => {
  //         if (l._id === item._id) {
  //           item.location = l.locations.length > 0 ? l.locations[0]._id : ''
  //         }
  //       })
  //     })
  //     this.setState({})
  //   } else {
  //     this.setState({
  //       [name]: value
  //     })
  //   }

  // }

  // screnningUpdated = () => {
  //   this.setState({
  //     loaderFlag: true
  //   })
  //   // this.state.screenDetails.map(item => {
  //   //   item.reminderTicketAvailable.consumed = item.reminderTicketAvailable.consumed + item.singleTicket.waitList
  //   // })
  //   this.setState({})
  //   if (this.validator.allValid()) {
  //     this.setState({
  //       loaderFlag: true
  //     })
  //     var data = {
  //       filmId: this.props.filmEditId,
  //       filmType: 'Film',
  //       screenDetails: this.state.screenDetails,
  //       totalAllow: {
  //         inPerson: this.state.total,
  //         online: this.state.online
  //        }
  //     };
  //     {/*
  //     awardWinner: { allowed: this.state.awardWinneraAllowed, opted: this.state.awardWinneraOpted, consumed: this.state.awardWinneraConsumed },
  //       catchUpAccess: { allowed: this.state.catchUpAccessAllowed, opted: this.state.catchUpAccessOpted, consumed: this.state.catchUpAccessConsumed },
  //       catchUpTickets: { allowed: this.state.catchUpTicketsAllowed, opted: this.state.catchUpTicketsOpted, consumed: this.state.catchUpTicketsConsumed },
  //       industryReservation: { allowed: this.state.industryReservationAllowed, opted: this.state.industryReservationOpted, consumed: this.state.industryReservationConsumed },
  //       premierTickets: { allowed: this.state.premierTicketsAllowed, opted: this.state.premierTicketsOpted, consumed: this.state.premierTicketsConsumed },
  //       publicPassHolder: { allowed: this.state.publicPassHolderAllowed, opted: this.state.publicPassHolderOpted, consumed: this.state.publicPassHolderConsumed },
  //     */}

  //     this.apiserve.sendevent("fpg|screening|update", data);
  //   }
  //   else {

  //     this.validator.showMessages();
  //     this.forceUpdate();
  //   }
  // }

  refreshScreening = (e) => {
    this.setState({
      loaderFlag: true
    })
    var data = { filmId: this.props.filmEditId };
    this.apiserve.sendevent("film|getAllDetail", data);
  }
  getScreeningName = (item) => {
    if(this.state.film !== undefined) {
      let screeningName = this.state.film.screnningTypeList && this.state.film.screnningTypeList.find(_ => _.type === item.screeningType && item?.locationType == _.locationType);
      return screeningName ? screeningName.name : 'N/A';
    }
  }

  render() {
    var settings = {
      customPaging: function (i) {
        return <a>{i + 1}</a>;
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    const {profileName, recordViewers, getLoginAdminByID} = this.props
    var userRole = localStorage.getItem('currentUserRole')
    let shortProgramme = new Date(this.state.shortProgramme && this.state.shortProgramme.date)

    const activeViewers = recordViewers || [];

    const { total, online, awardWinneraAllowed, awardWinneraOpted, awardWinneraConsumed, catchUpAccessAllowed, catchUpAccessConsumed, catchUpTicketsOpted,
      catchUpTicketsAllowed, catchUpAccessOpted, catchUpTicketsConsumed, industryReservationAllowed, industryReservationOpted, industryReservationConsumed,
      premierTicketsAllowed, premierTicketsOpted, premierTicketsConsumed, premierTicketsWaitList, publicPassHolderAllowed, publicPassHolderOpted, publicPassHolderConsumed, lastUpdatedBy, lastUpdatedAt, holdSceeringAvailableOpted, online_held, total_held,onlineAllocation_consumed,onlineAllocation_allowed,inPersonAllocation_allowed,inPersonAllocation_consumed } = this.state
    let premierTicketsAllowedCal = premierTicketsAllowed - premierTicketsOpted
    let publicPassHolderAllowedCal = publicPassHolderAllowed - publicPassHolderOpted
    let industryReservationAllowedCal = industryReservationAllowed - industryReservationOpted
    let remainderSceeringAvailableOpted = premierTicketsAllowedCal + publicPassHolderAllowedCal + industryReservationAllowedCal
    let remainderSceeringAvailableConsumed = premierTicketsConsumed + publicPassHolderConsumed + industryReservationConsumed
    return (
      <>
        <RecordPresenceBanner activeViewers={activeViewers} conflict={null} />
        <div className="fpg_tabcontent d_flex">
        {/* {getAlldataFilm && getAlldataFilm.length && getAlldataFilm.map((item,index)=>( */}
        <>
        <div className="tab_col left_col">
          <div className="d_flex id_media d_flex_align_center">
            { <span className="id_text">
              <label>Eventive  ID:</label> {this.state.eventiveId}
            </span>}
            <span className="id_text">
              <label>Media ID:</label> {this.state.mediaId}
            </span>
            {/* <span className="id_text">
              <label>Filemaker ID:</label> {this.state.fileMakerId}
            </span> */}
            {/* <span className="id_text">
                <label>Shift72 ID:</label>
                {this.state.shift72Id}
              </span> */}
          </div>
          <Slider {...settings}>
            {this.state.images &&
              this.state.images.map((item) => (
                <div>
                  <div className="media_image">
                    <img
                      src={
                        item.inSite ? this.apiserve.imageUrl + item.inSite :
                          item.link ? item.link :
                            '/images/image-placeholder.png'
                      }
                      alt="image"
                    />
                  </div>
                </div>
              ))}
          </Slider>
          <div>
            <div className="program_header d_flex">
                <h3>Shorts Included in film</h3>
            </div>
            <div className="program_inner">
                {
                    (this.state?.shortFilms.length > 0) && 
                    <ul>
                        {
                            this.state.shortFilms.map((item) => (
                                <li key={item._id}>
                                    <div className="d_flex list_inner d_flex_align_center">
                                        <div className="program_contents d_flex">
                                            <div className="program_image">
                                                <img 
                                                    src={item?.images?.inSite 
                                                            ? (this.apiserve.imageUrl + item.images.inSite) 
                                                            : item?.images?.link          
                                                                ? item.images.link
                                                                : '/images/image-placeholder.png'
                                                        }
                                                    alt='Short Film'
                                                />
                                            </div>
                                            <div className="program_contents_desc">
                                                <h2 className="program_title">{item?.title}</h2>
                                                <p className="program_time">{item?.runTime} min</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                }
            </div>
          </div>
          <div className="credit_section mt_15">
            <div className="credit_header">
              <h5>Credits</h5>
            </div>
            <div className="credit_content">
              <ul>
                <li className="d_flex">
                  {this.state.credits &&
                    this.state.credits.map((item) => (
                      <>
                      <label>{item && item.creditId && item.creditId.name}</label>
                      <span className="name">
                        {item.creditType &&
                          item.creditType.map((creditTypeName) => (
                            <p>{creditTypeName.creditsInsideType}</p>
                          ))}
                      </span>
                      </>
                    ))}
                </li>
              </ul>
            </div>
          </div>
          <div className="credit_section artist_section">
            <div className="credit_header">
              <h5>Meet The Artist</h5>
            </div>
            <div className="artist_content">
              {this.state.artist.map((item) => {
                return (
                  <>
                  <div className="d_flex inner_artist mb_15">

                    <div className="artist_user">
                      <img
                        src={

                          item.image
                            ? this.apiserve.imageUrl + item.image
                            : '/images/user.png'
                        }
                        alt="user"
                      />
                    </div>
                    <div className="artist_data">
                      <div className="d_flex user_name">
                        <h4>{item.name}</h4>
                        <div className="d_flex d_flex_align_center">
                          {item.twitter &&
                            <Link
                              className="d_flex d_flex_align_center"
                              onClick={() => this.handelTwitter(item)}
                            >
                              <TwitterIcon />
                            </Link>
                          }
                          {item.instagram &&
                            <Link
                              className="d_flex d_flex_align_center"
                              onClick={() => this.handelInstagram(item)}
                            >
                              <InstaIcon />
                            </Link>
                          }
                        </div>
                      </div>
                      <div className="user_desc">
                        {/* <p>{item.description}</p> */}
                        <div className="editor_view" dangerouslySetInnerHTML={{ __html: item.description }} />
                      </div>
                      <div className="video_wrap">
                        <iframe src={getEmbedUrl(item.youtube)}></iframe>
                      </div>
                    </div>
                  </div>
                  </>
                )
              })}
            </div>
          </div>
        </div>
        <div className="tab_col feature_col" style={{maxWidth:`calc(100% - 460px)`}}>
          <div className="fpg_edits_links d_flex d_flex_align_center">
            <Link className="d_flex d_flex_align_center d_flex_justify_center"
              onClick={this.editFilmEvent}
            >
              <FpgeeditIcon />
              EDIT
              </Link>
            {this.state.status === 1 ?
              <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.disableFilm()}>
                <FpgDisableIcon /> DISABLE
                </Link>
              :
              <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.publishFilm()}>
                <FpgpublishIcon /> PUBLISH
                </Link>
            }
            {this.state.hideFromLive === true ?
              <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.hideFromLiveFilm()}>
                 <ViewIcon /> Show On Live
                </Link>
              :
              <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.showFromLiveFilm()}>
                 <ShowPassIcon /> Hide From Live
                </Link>
            }
            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.deleteFilm()}>
              <FpgDeleteIcon />
              DELETE
              </Link>
          </div>
          <div className="id_text mt_5 mb_10">
            <li className="d_flex">
              <label>Access: </label>
              <span>&nbsp;{this.state.access}</span>
            </li>

          </div>
          <p className="feature_text">{this.state.categoryname}</p>
          <div className="feature_title">
            <h3>{this.state.title}</h3>
            {/* <p>{this.state.description}</p> */}
            {/* {parse(`${this.state.description}`)} */}

            <div className="field_row mb_25">
              <label className="font_600"> Long Description</label>
              <div className="editor_view" dangerouslySetInnerHTML={{ __html: this.state.description }} />
            </div>
            <div className="field_row mb_25">
              <label className="font_600">Short Description</label>
              <div className="editor_view" dangerouslySetInnerHTML={{ __html: this.state.shortDescription }} />
            </div>
          </div>
          <div className="data_list">
            <ul>
              <li className="d_flex">
                <label>Short Introduction</label>
                <span>{this.state.shortIntroduction}</span>
              </li>
              <li className="d_flex">
                <label>Article</label>
                <span>{this.state.article}</span>
              </li>
              <li className="d_flex">
                <label>Year</label>
                <span>{this.state.year}</span>
              </li>
              <li className="d_flex">
                <label>Category</label>
                <span>{this.state.category ?.name}</span>
              </li>
              <li className="d_flex">
                <label>Country</label>
                <span>{this.state.country}</span>
              </li>
              <li className="d_flex">
                <label>Language</label>
                <span>{this.state.language}</span>
              </li>
              <li className="d_flex">
                <label>Run Time</label>
                <span>{this.state.runTime}</span>
              </li>
              <li className="d_flex">
                <label>Company</label>
                <span>{this.state.company}</span>
              </li>
              <li className="d_flex">
                <label>Website</label>
                <span>{this.state.website}</span>
              </li>
              <li className="d_flex">
                <label>Contact</label>
                <span>
                  {this.state.contact &&
                    this.state.contact.map((item) => <p>{item && item.emailPhone}</p>)}
                </span>
              </li>
            </ul>
            <ul>
              <li className="d_flex">
                <label>Genre</label>
                <span>
                  {this.state.genre &&
                    this.state.genre.map((item) => <p>{item.name}</p>)}
                </span>
              </li>
              <li className="d_flex">
                <label>Interest Tracks</label>
                <span>
                  {this.state.interestTrack &&
                    this.state.interestTrack.map((item) => (
                      <p>{item.name}</p>
                    ))}
                </span>
              </li>
              <li className="d_flex">
                <label>Accessibility</label>
                <span>
                  {this.state.accessibility &&
                    this.state.accessibility.map((item) => (
                      <p>{item.name}</p>
                    ))}
                </span>
              </li>
            </ul>
          </div>

          <div className="data_list">
            <ul>
              <li className="d_flex">
                <label>Award Category</label>
                <span>{this.state.awardCategory}</span>
              </li>
              <li className="d_flex">
                <label>Award Sponsor Logo</label>

                <span>
                  <img
                    src={
                      this.state.awardSponsorLogo ?
                        this.apiserve.imageUrl + this.state.awardSponsorLogo :
                        '/images/image-placeholder.png'
                    }
                    alt="image"
                  /></span>
              </li>
              <li className="d_flex">
                <label>Votes</label>
                <span>{this.state.votes}</span>
              </li>
              {/* <li className="d_flex">
                <label>Audio Description</label>
                <span>{this.state.isAudioDescription ? 'Yes' : 'No'}</span>
              </li> */}
              <li className="d_flex">
                <label>Explicit Content</label>
                <span>{this.state.isExplicitContent ? 'Yes' : 'No'}</span>
              </li>
              <li className="d_flex">
                <label>Explicit Content Disclaimer</label>
                {/* <span>{this.state.explicitContent}</span> */}
                <div className="right_editor"><div className="editor_view p_0" dangerouslySetInnerHTML={{ __html: this.state.explicitContent }} ></div></div>
              </li>
              <li className="d_flex">
                <label>Film Sponsor Logo</label>
                <span>
                  <img
                    src={
                      this.state.sponsorLogo ?
                        this.apiserve.imageUrl + this.state.sponsorLogo :
                        '/images/image-placeholder.png'
                    }
                    alt="image"
                  />
                </span>
              </li>
            </ul>
            <ul>
              <li className="d_flex">
                <label>Screening More info Title</label>
                <span>{this.state.screeningMoreInfoTitle}</span>
              </li>
              <li className="d_flex">
                <label>Screening - More Info</label>
                <div className="right_editor"><div className="editor_view p_0" dangerouslySetInnerHTML={{ __html: this.state.screeningMoreInfo }}></div></div>
              </li>

            </ul>
          </div>

          {this?.state?.category?.type !== 2 && <div className="screen_dates" style={{ maxWidth: "800px" }}>
            <table>
              <thead>
                <tr>
                  <th>Event Start Date & Time (MT) - Event End Date & Time (MT)</th>
                  <th>Screening Type</th>
                  <th>Location</th>
                  <th>Waitlist Slots</th>
                  <th>Accessibility</th>
                  <th>Interest Tracks</th>
                  <th>Supress Voting</th>
                </tr>
              </thead>
              <tbody>
              {this.state.category && (this.state.category._id === '5fa7d17c0329c105a039f9f7' || this.state.category.value === '5fa7d17c0329c105a039f9f7') ?
                  this.state.shortProgramme && this.state.shortProgramme.dateTime?.length >= 1 && this.state.shortProgramme.dateTime.map((item) => {
                    return (
                      item.locationType === "2" ?
                        <>
                        <tr className="disp_flex">
                          <td>{moment(item.date).tz("US/Mountain").format('MMM DD')}
                          <span className="time_text">
                            {moment(item.date).tz("US/Mountain").format('h:mm A')}
                          </span>
                          </td>
                            <td className="screening_type">
                            {this.getScreeningName(item) }
                          </td>
                          <td className="d_flex">

                            {
                              item ?.locationType === undefined || item.locationType === "2" ? <span className="d_block"> Online </span> :
                                item ?.locations.length > 0 ? item ?.locations && item.locations ?.map((loc) => {
                                  return <span className="d_block"> {loc ?.name} &nbsp;</span>
                                }) : ''
                                }

                          </td>
                          <td className="waitlist_slot">{(item.maxWaitListSlots === 0 && item?.locationType === "1") ? <span className="sd_zero_waitlist_slots">0 Waitlist Slots</span> : item.maxWaitListSlots}</td>
                          <td className="waitlist_slot">{item.accessibility.length > 0 ? item?.accessibility[0]?.name : '-'} {item?.accessibility.length > 1 && <>
                            <span>+ More</span>
                            <div className="tooltip_box">{item?.accessibility.map((acc, i) => {return (<span>{acc?.name}</span>)}) }</div>
                          </>}</td>
                          <td className="waitlist_slot">{renderInterestTracks(item.interestTrack, this.state.film.interestTrack)}</td>
                          <td className="waitlist_slot">{item.supressVoting ? 'Y' : 'N'}</td>
                        </tr>
                        </>
                        :
                          <>
                          <tr className="disp_flex">
                            <td>{moment(item.date).tz("US/Mountain").format('MMM DD')}
                            <span className="time_text">
                              {moment(item.date).tz("US/Mountain").format('h:mm A')}
                            </span>
                            </td>
                             <td className="screening_type">
                            {this.getScreeningName(item) }
                          </td>
                            <td className="d_flex">

                              {
                                item.locationType === "1" &&
                                  item ?.locations.length > 0 ? item ?.locations ?.map((loc) => {
                                    return <span className="d_block"> {loc ?.name} &nbsp;</span>
                                  }) : ''
                                    }

                            </td>
                            <td className="waitlist_slot">{(item.maxWaitListSlots === 0 && item?.locationType === "1") ? <span className="sd_zero_waitlist_slots">0 Waitlist Slots</span> : item.maxWaitListSlots}</td>
                            <td className="waitlist_slot">{item.accessibility.length > 0 ? item?.accessibility[0]?.name : '-'} {item?.accessibility.length > 1 && <>
                              <span>+ More</span>
                              <div className="tooltip_box">{item?.accessibility.map((acc, i) => {return (<span>{acc?.name}</span>)}) }</div>
                            </>}</td>
                            <td className="waitlist_slot">{renderInterestTracks(item.interestTrack, this.state.film.interestTrack)}</td>
                            <td className="waitlist_slot">{item.supressVoting ? 'Y' : 'N'}</td>
                          </tr>
                          </>

                    )
                  })
                  :
                  this.state.dateTime && this.state.dateTime.length >= 1 &&
                  this.state.dateTime &&
                  this.state.dateTime.map((item) => {
                    var fpgFlimViewStart = new Date(item.date);
                    var fpgFlimViewEnd = new Date(item.endDate);
                    console.log('this.state.dateTime view:::',this.state.dateTime)
                    return (
                      <>
                      {item.date !== undefined && 
                        <tr>
                            <td className="time_text time_text_nf">
                              {moment(fpgFlimViewStart).tz("US/Mountain").format('MMM DD')} {moment(fpgFlimViewStart).tz("US/Mountain").format('h:mm A')}  -  {moment(fpgFlimViewEnd).tz("US/Mountain").format('MMM DD')} {moment(fpgFlimViewEnd).tz("US/Mountain").format('h:mm A')}
                            </td>
                            <td className="screening_type">
                            {this.getScreeningName(item) }
                          </td>
                          <td>

                            {
                              item ?.locationType === undefined || item.locationType === "2" ? <span className="d_block"> Online </span> :
                                item ?.locations.length > 0 ? item ?.locations && item ?.locations ?.map((loc) => {
                                  return <span className="d_block"> {loc ?.name} &nbsp;</span>
                                }) : ''
                                  }

                          </td>
                          <td className="waitlist_slot">{(item.maxWaitListSlots === 0 && item?.locationType === "1") ? <span className="sd_zero_waitlist_slots">0 Waitlist Slots</span> : item.maxWaitListSlots}</td>
                          <td className="waitlist_slot">{item.accessibility.length > 0 ? item?.accessibility[0]?.name : '-'} {item?.accessibility.length > 1 && <>
                            <span>+ More</span>
                            <div className="tooltip_box">{item?.accessibility.map((acc, i) => {return (<span>{acc?.name}</span>)}) }</div>
                          </>}</td>
                          <td className="waitlist_slot">{renderInterestTracks(item.interestTrack, this.state.film.interestTrack)}</td>
                          <td className="waitlist_slot">{item.supressVoting ? 'Y' : 'N'}</td>
                        </tr>
                      }
                      </>
                    )
                  })
                }
              </tbody>
            </table>
          </div>}
          {/* <div className="data_list">
          <ul>
              <li className="d_flex">
                <label>My Library Screening Code:</label>
                <span>{this.state.myLibraryScreeningCode}</span>
              </li>
         </ul>
         </div> */}
          {this.state.qaReplayLink &&
            <div className="data_list">
              <ul>
                <li className="d_flex">
                  <label>QA Link</label>
                  <span>{this.state.qaReplayLink}</span>
                </li>
              </ul>
            </div>
          }
          <div className="connection_detail">
            {/* <div className="connection_header">
              <h2>Film Team Connection Details</h2>
            </div>
            <div className="connection_data">
              <div className="connection_box">
                <h3 className="uppercase">connection 1</h3>
                <div className="connection_list">
                  <ul>
                    {/* {this.state.teamConnection &&
                        this.state.teamConnection.map((item,index) => (
                          <> *
                    <li>
                      <label>Full Name</label>{" "}
                      <span>{this.state.teamConnectionFirstName}</span>
                    </li>
                    <li>
                      <label>Email</label>{" "}
                      <span>{this.state.teamConnectionFirstEmail}</span>
                    </li>
                    {/* </>
                        ))} 
                  </ul>
                </div>
              </div>
              <div className="connection_box">
                <h3 className="uppercase">connection 2</h3>
                <div className="connection_list">
                  <ul>
                    <li>
                      <label>Full Name</label>{" "}
                      <span>{this.state.teamConnectionSecondName}</span>
                    </li>
                    <li>
                      <label>Email</label>{" "}
                      <span>{this.state.teamConnectionSecondEmail}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
            <div className="paf_screening_info mt_25 w_100 border_btm_1 pb_25">
              <h2 className="paf_screening_info_title mb_10">Film Team - Public Contact Information</h2>
              <div className="mb_10">
                  <p className="paf_screening_info_subtitle uppercase mb_15">PUBLIC CONTACT (DURING FESTIVAL)</p>
                  <div className="data_list">
                      <ul className="mb_5">
                          <li className="d_flex">
                              <label>First Name</label>
                              <span>{this.state.publicContact?.firstName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Middle Name</label>
                              <span>{this.state.publicContact?.middleName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Last Name</label>
                              <span>{this.state.publicContact?.lastName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Company</label>
                              <span>{this.state.publicContact?.company}</span>
                          </li>
                          <li className="d_flex">
                              <label>Public Email</label>
                              <span>{this.state.publicContact?.publicEmail}</span>
                          </li>
                          <li className="d_flex">
                              <label>Website</label>
                              <span>{this.state.publicContact?.website}</span>
                          </li>
                          <li className="d_flex">
                              <label>Phone</label>
                              <span>{this.state.publicContact?.phoneNumber}</span>
                          </li>
                          <li className="d_flex">
                              <label>Phone Type</label>
                              <span>{this.state.publicContact?.type}</span>
                          </li>
                      </ul>
                  </div>
              </div>
              <div className="mb_10">
                  <p className="paf_screening_info_subtitle uppercase mb_15">POST FESTIVAL CONTACT (AFTER FESTIVAL)</p>
                  <div className="data_list">
                      <ul className="mb_5">
                          <li className="d_flex">
                              <label>First Name</label>
                              <span>{this.state.postFestivalContact?.firstName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Middle Name</label>
                              <span>{this.state.postFestivalContact?.middleName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Last Name</label>
                              <span>{this.state.postFestivalContact?.lastName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Company</label>
                              <span>{this.state.postFestivalContact?.company}</span>
                          </li>
                          <li className="d_flex">
                              <label>Public Email</label>
                              <span>{this.state.postFestivalContact?.publicEmail}</span>
                          </li>
                          <li className="d_flex">
                              <label>Website</label>
                              <span>{this.state.postFestivalContact?.website}</span>
                          </li>
                          <li className="d_flex">
                              <label>Phone</label>
                              <span>{this.state.postFestivalContact?.phoneNumber}</span>
                          </li>
                          <li className="d_flex">
                              <label>Phone Type</label>
                              <span>{this.state.postFestivalContact?.type}</span>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
          </div>
        </div>
        {/* { (userRole === 'admin' || this.getDisplayValue(4)) && this.state.onlineScreeningShow === false  ? <div className="tab_col screen_col">
          <div className="inner_screen">
            <div className="screen_header text_center pointer" onClick={(e) => this.ScreenToggle(e)}>
              <h2>Screenings</h2>
            </div>

            <div className="screen_content_outer">
              <div className="pointer text_right" onClick={(e) => this.refreshScreening(e)}>
                <p className="mr_25 mt_10"><RefreshIcon /></p>
              </div>
              <div className="screen_content">
                <p className="text_center update_text">
                  {lastUpdatedAt &&
                    <i>Last Updated on {moment(lastUpdatedAt).format('MM/DD/YY')} by {(lastUpdatedBy ? lastUpdatedBy.fname : '-') + ' ' + (lastUpdatedBy ? lastUpdatedBy.lname : '-')}</i>
                  }
                </p>

                <form>
                  <div className="d_flex d_flex_justify_end">
                    <div className="premier_title"> </div>
                    <div className="screen_field field_row d_flex d_flex_align_center">
                      <label className="uppercase screen_label">Total Allowed</label>
                      <div className="field_wrap total_allowed mr_5">
                        <TextField
                          type="text"
                          name="total"
                          placeholder="5000"
                          onChange={(e) => this.handleChange(e)}
                          value={total}
                          label="IN-PERSON"
                          disable={false}
                        />
                      </div>
                      <div className="field_wrap total_allowed">
                        <TextField
                          type="text"
                          name="online"
                          placeholder="5000"
                          onChange={(e) => this.handleChange(e)}
                          value={online}
                          label="ONLINE"
                          disable={false}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d_flex d_flex_justify_end">
                    <div className="premier_title"> </div>
                    <div className="screen_field field_row d_flex d_flex_align_center">
                      <label className="uppercase screen_label">In-Person Total Allocation</label>
                      <div className="field_wrap total_allowed mr_5">
                        <TextField
                          type="number"
                          name="inPersonAllocation_allowed"
                          placeholder="0"
                          onChange={(e) => this.handleChange(e)}
                          value={inPersonAllocation_allowed}
                          disable={true}
                        />
                      </div>
                      <div className="field_wrap total_allowed consumed_input">
                        <TextField
                          type="number"
                          name="inPersonAllocation_consumed"
                          placeholder="0"
                          onChange={(e) => this.handleChange(e)}
                          value={inPersonAllocation_consumed}
                          disable={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d_flex d_flex_justify_end">
                    <div className="premier_title"> </div>
                    <div className="screen_field field_row d_flex d_flex_align_center">
                      <label className="uppercase screen_label">Online Total Allocation</label>
                      <div className="field_wrap total_allowed mr_5">
                        <TextField
                          type="number"
                          name="onlineAllocation_allowed"
                          placeholder="0"
                          onChange={(e) => this.handleChange(e)}
                          value={onlineAllocation_allowed}
                          disable={true}
                        />
                      </div>
                      <div className="field_wrap total_allowed consumed_input">
                        <TextField
                          type="number"
                          name="onlineAllocation_consumed"
                          placeholder="0"
                          onChange={(e) => this.handleChange(e)}
                          value={onlineAllocation_consumed}
                          disable={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d_flex d_flex_justify_end">
                    <div className="premier_title"> </div>
                    <div className="screen_field field_row d_flex d_flex_align_center">
                      <label className="uppercase screen_label">Total Held</label>
                      <div className="field_wrap total_allowed mr_5">
                        <TextField
                          type="number"
                          name="total_held"
                          placeholder="0"
                          onChange={(e) => this.handleChange(e)}
                          value={total_held}
                          disable={true}
                        />
                      </div>
                      <div className="field_wrap total_allowed consumed_input">
                        <TextField
                          type="number"
                          name="online_held"
                          placeholder="0"
                          onChange={(e) => this.handleChange(e)}
                          value={online_held}
                          disable={true}
                        />
                      </div>
                    </div>
                  </div>
                 
                  <div className="d_flex d_flex_justify_end">
                    <div className="premier_title"> </div>
                    <div className="screen_two_field field_row d_flex d_flex_align_center">
                      <label className="uppercase">&nbsp;</label>
                      <div className="field_wrap disp_flex">
                        <div className="field_row_inner">
                          <h4 className="uppercase">Allowed</h4>
                        </div>
                        <div className="field_row_inner">
                          <h4 className="uppercase">Opted</h4>
                        </div>
                        <div className="field_row_inner">
                          <h4 className="uppercase">consumed</h4>
                        </div>
                        {this.state.waitList_show && 
                          <div className="field_row_inner">
                            <h4 className="uppercase">waitList</h4>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  {this.state.screenDetails ?.map((item, i) => {
                    return (
                      // (this.state.categorytype !== 2 || this.state.categorytype !== 3) && item.locationType !== "2" ? 
                        <div className="d_flex d_flex_justify_end">
                          <div className="premier_title">
                            <h3 className="text_white uppercase">{item.screeningType === '1' ? 'Premiere' : item.screeningType === '2' ? 'Second Screening' : item.screeningType === '3' ? 'Award Winner' : ''} </h3>
                            <h3 className="text_white uppercase">{moment(item.date).tz('US/Mountain').format('MMM DD h:mm a')}</h3>
                            <h3 className="text_white uppercase">{this.state.dateTime.map(_ => _._id === item._id ? _.locations.length > 0 ? _.locations[0].name : 'Online' : '')} </h3>
                          </div>
                          <div className="screen_right_fields">
  
                            <div className="screen_two_field field_row d_flex d_flex_align_center">
                              <label className="uppercase">single tickets</label>
                              <div className="field_wrap disp_flex">
                                <TextField type="text" name="premierTicketsAllowed" placeholder="1000" value={item.singleTicket.allowed} onChange={(e) => this.handleChange(e, item._id)} />
                                <TextField type="number" name="premierTicketsOpted" placeholder="500" value={item.singleTicket.opted} onChange={(e) => this.handleChange(e, item._id)} disable={true} />
                                <TextField type="number" name="premierTicketsConsumed" placeholder="200" value={item.singleTicket.consumed} onChange={(e) => this.handleChange(e, item._id)} disable={true} />
                                {this.state.dateTime.map(l =>
                                  l._id === item._id ? l.locations.length > 0 &&
                                    <TextField type="text" name="premierTicketsWaitList" placeholder="200" value={item.singleTicket.waitList} onChange={(e) => this.handleChange(e, item._id)} disable={false} /> : ''
                                )}
  
                              </div>
                            </div>
                            <div className="screen_two_field field_row d_flex d_flex_align_center">
                              <label className="uppercase">public package Tickets</label>
                              <div className="field_wrap disp_flex">
                                <TextField type="text" name="publicPassHolderAllowed" placeholder="1000" value={item.publicPackageTicket.allowed} onChange={(e) => this.handleChange(e, item._id)} />
                                <TextField type="number" name="publicPassHolderOpted" placeholder="500" value={item.publicPackageTicket.opted} onChange={(e) => this.handleChange(e, item._id)} disable={true} />
                                <TextField type="number" name="publicPassHolderConsumed" placeholder="200" value={item.publicPackageTicket.consumed} onChange={(e) => this.handleChange(e, item._id)} disable={true} />
                                {this.state.waitList_show && 
                                <div class="field_row_inner"></div>
                              }
                              </div>
                            </div>
                            <div className="screen_two_field field_row d_flex d_flex_align_center">
                              <label className="uppercase">P&I Package Tickets</label>
                              <div className="field_wrap disp_flex">
                                <TextField type="text" name="industryReservationAllowed" placeholder="500" value={item.piPackageTicket.allowed} onChange={(e) => this.handleChange(e, item._id)} />
                                <TextField type="number" name="industryReservationOpted" placeholder="300" value={item.piPackageTicket.opted} onChange={(e) => this.handleChange(e, item._id)} disable={true} />
                                <TextField type="number" name="industryReservationConsumed" placeholder="200" value={item.piPackageTicket.consumed} onChange={(e) => this.handleChange(e, item._id)} disable={true} />
                                {this.state.waitList_show && 
                                <div class="field_row_inner"></div>
                              }
                              </div>
                            </div>
                            <div className="screen_two_field field_row d_flex d_flex_align_center">
                              <label className="uppercase">Hold Tickets</label>
                              <div className="field_wrap d_flex reminder_field">
                                <TextField type="text" name="holdSceeringAvailableAllowed" placeholder="3300" value={item.holdTickets.allowed} onChange={(e) => this.handleChange(e, item._id)} disable={false} />
                                <TextField type="number" name="holdSceeringAvailableOpted" placeholder="200" value={item.holdTickets.opted} onChange={(e) => this.handleChange(e, item._id)} disable={true} />
                                <TextField type="number" name="holdSceeringAvailableconsumed" placeholder="200" value={item.holdTickets.consumed} onChange={(e) => this.handleChange(e, item._id)} disable={true} />
                                {this.state.waitList_show && 
                                <div class="field_row_inner"></div>
                              }
                              </div>
                            </div>
                            <div className="screen_two_field field_row d_flex d_flex_align_center">
                              <label className="uppercase">remainder OF Tickets AVAILABLE</label>
                              <div className="field_wrap d_flex reminder_field">
                                <TextField type="number" name="reminderTicketAvailableAlloed" placeholder="3300" value={item.reminderTicketAvailable ?.allowed} onChange={(e) => this.handleChange(e, item._id)} disable={true} />
                                {!this.state.waitList_show ?
                                <TextField type="number" name="reminderTicketAvailableConsumed" placeholder="200" value={item.reminderTicketAvailable ?.consumed } onChange={(e) => this.handleChange(e, item._id)} disable={true} /> 
                                : <TextField type="number" name="reminderTicketAvailableConsumed" placeholder="200" value={parseInt(item.reminderTicketAvailable ?.consumed) + parseInt(item.singleTicket.waitList)} onChange={(e) => this.handleChange(e, item._id)} disable={true} />}
                              </div>
                            </div>
                          </div>
                        </div>
                        //  : ''
                      
                    )
                    
                  })}
                  { /*<div className="d_flex">
                    <div className="premier_title">
                      <h3 className="text_white uppercase">Premiere </h3>
                      <h3 className="text_white uppercase">Jan 30 7:00pm</h3>
                      <h3 className="text_white uppercase"> The Ray</h3>
                    </div>
                    <div className="screen_right_fields">

                      <div className="screen_two_field field_row d_flex d_flex_align_center">
                        <label className="uppercase">single tickets</label>
                        <div className="field_wrap disp_flex">
                          <TextField type="number" name="premierTicketsAllowed" placeholder="1000" value={premierTicketsAllowed} onChange={this.handleChange} />
                          <TextField type="number" name="premierTicketsOpted" placeholder="500" value={premierTicketsOpted} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="premierTicketsConsumed" placeholder="200" value={premierTicketsConsumed} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="premierTicketsWaitList" placeholder="200" value={premierTicketsWaitList} onChange={this.handleChange} disable={true} />
                        </div>
                      </div>
                      <div className="screen_two_field field_row d_flex d_flex_align_center">
                        <label className="uppercase">public package Tickets</label>
                        <div className="field_wrap disp_flex">
                          <TextField type="number" name="publicPassHolderAllowed" placeholder="1000" value={publicPassHolderAllowed} onChange={this.handleChange} />
                          <TextField type="number" name="publicPassHolderOpted" placeholder="500" value={publicPassHolderOpted} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="publicPassHolderConsumed" placeholder="200" value={publicPassHolderConsumed} onChange={this.handleChange} disable={true} />
                        </div>
                      </div>
                      <div className="screen_two_field field_row d_flex d_flex_align_center">
                        <label className="uppercase">P&I Package Tickets</label>
                        <div className="field_wrap disp_flex">
                          <TextField type="number" name="industryReservationAllowed" placeholder="500" value={industryReservationAllowed} onChange={this.handleChange} />
                          <TextField type="number" name="industryReservationOpted" placeholder="300" value={industryReservationOpted} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="industryReservationConsumed" placeholder="200" value={industryReservationConsumed} onChange={this.handleChange} disable={true} />
                        </div>
                      </div>
                      <div className="screen_two_field field_row d_flex d_flex_align_center">
                        <label className="uppercase">remainder OF Tickets AVAILABLE</label>
                        <div className="field_wrap d_flex reminder_field">
                          <TextField type="number" name="total" placeholder="3300" value={remainderSceeringAvailableOpted} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="total2" placeholder="200" value={remainderSceeringAvailableConsumed} onChange={this.handleChange} disable={true} />
                        </div>
                      </div>
                      <div className="screen_two_field field_row d_flex d_flex_align_center">
                        <label className="uppercase">Hold Tickets</label>
                        <div className="field_wrap d_flex reminder_field">
                          <TextField type="number" name="total" placeholder="3300" value={remainderSceeringAvailableOpted} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="total2" placeholder="200" value={remainderSceeringAvailableConsumed} onChange={this.handleChange} disable={true} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d_flex">
                    <div className="premier_title">
                      <h3 className="text_white uppercase">Premiere </h3>
                      <h3 className="text_white uppercase">Jan 30 7:00pm</h3>
                      <h3 className="text_white uppercase"> The Ray</h3>
                    </div>
                    <div className="screen_right_fields">
                      <div className="screen_two_field field_row d_flex d_flex_align_center">
                        <label className="uppercase">single tickets</label>
                        <div className="field_wrap disp_flex">
                          <TextField type="number" name="premierTicketsAllowed" placeholder="1000" value={premierTicketsAllowed} onChange={this.handleChange} />
                          <TextField type="number" name="premierTicketsOpted" placeholder="500" value={premierTicketsOpted} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="premierTicketsConsumed" placeholder="200" value={premierTicketsConsumed} onChange={this.handleChange} disable={true} />
                        </div>
                      </div>
                      <div className="screen_two_field field_row d_flex d_flex_align_center">
                        <label className="uppercase">public package Tickets</label>
                        <div className="field_wrap disp_flex">
                          <TextField type="number" name="publicPassHolderAllowed" placeholder="1000" value={publicPassHolderAllowed} onChange={this.handleChange} />
                          <TextField type="number" name="publicPassHolderOpted" placeholder="500" value={publicPassHolderOpted} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="publicPassHolderConsumed" placeholder="200" value={publicPassHolderConsumed} onChange={this.handleChange} disable={true} />
                        </div>
                      </div>
                      <div className="screen_two_field field_row d_flex d_flex_align_center">
                        <label className="uppercase">P&I Package Tickets</label>
                        <div className="field_wrap disp_flex">
                          <TextField type="number" name="industryReservationAllowed" placeholder="500" value={industryReservationAllowed} onChange={this.handleChange} />
                          <TextField type="number" name="industryReservationOpted" placeholder="300" value={industryReservationOpted} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="industryReservationConsumed" placeholder="200" value={industryReservationConsumed} onChange={this.handleChange} disable={true} />
                        </div>
                      </div>
                      <div className="screen_two_field field_row d_flex d_flex_align_center">
                        <label className="uppercase">remainder OF Tickets AVAILABLE</label>
                        <div className="field_wrap d_flex reminder_field">
                          <TextField type="number" name="total" placeholder="3300" value={remainderSceeringAvailableOpted} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="total2" placeholder="200" value={remainderSceeringAvailableConsumed} onChange={this.handleChange} disable={true} />
                        </div>
                      </div>
                      <div className="screen_two_field field_row d_flex d_flex_align_center">
                        <label className="uppercase">Hold Tickets</label>
                        <div className="field_wrap d_flex reminder_field">
                          <TextField type="number" name="total" placeholder="3300" value={remainderSceeringAvailableOpted} onChange={this.handleChange} disable={true} />
                          <TextField type="number" name="total2" placeholder="200" value={remainderSceeringAvailableConsumed} onChange={this.handleChange} disable={true} />
                        </div>
                      </div>
                    </div>
                </div>*

                  <div className="field_row text_center pt_15 pb_10">
                    <button className="active" type='button' onClick={() => this.screnningUpdated()}>SAVE</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div> : ''} */}
        </>
        {/* ))} */}
        {
          this.state.errorPopup ?
            <ErrorPopUp
              errorMsg={this.state.errorMsg}
              errorMsgPopup={this.errorMsgPopup}
            />
            : ''
        }
        {
          this.state.deleteFilm ?
            <PopUpCustomAll
              HeaderName='Delete?'
              insideDetails='You are about to delete an item and this action is permanent'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.deleteFilmPopupYes}
            />
            : ''
        }

        {
          this.state.publishFilm ?
            <PopUpCustomAll
              HeaderName='Publish Changes'
              insideDetails='Saving the current changes will publish it to the production site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.publishFilmPopupYes}
            />
            : ''
        }
        {
          this.state.showFromLiveFilm ?
            <PopUpCustomAll
              HeaderName='Hide From Live'
              insideDetails='Saving the current changes will hide it from the site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.hideFromLiveFilmPopupYes}
            />
            : ''
        }

        {
          this.state.disableFilm ?
            <PopUpCustomAll
              HeaderName='Disable?'
              insideDetails='You are about to disable an item, which will temporarily make it unavailable on the production site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.disableFilmPopupYes}
            />
            : ''
        }
        {
          this.state.hideFromLiveFilm ?
            <PopUpCustomAll
              HeaderName='Show On Live?'
              insideDetails='Saving the current changes will show it to the site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.showFromLiveFilmPopupYes}
            />
            : ''
        }
        {
          this.state.loaderFlag ? (
            <Loader />
          ) : (
              ""
            )
        }

      </div >
      </>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(FpgFilmDetailView)